import React, { useEffect, useState } from 'react';
import { Chip, alpha, useTheme } from '@mui/material';
import { getMarketStatus } from './marketHours';

const MarketStatusChip: React.FC = () => {
  const theme = useTheme();
  const [status, setStatus] = useState(getMarketStatus());
  useEffect(() => {
    const id = setInterval(() => setStatus(getMarketStatus()), 60_000);
    return () => clearInterval(id);
  }, []);
  return (
    <Chip
      size="small"
      label={status.label}
      sx={{
        fontWeight: 600,
        bgcolor: status.open
          ? alpha(theme.palette.success.main, 0.12)
          : alpha(theme.palette.text.primary, 0.08),
        color: status.open ? 'success.main' : 'text.secondary',
      }}
    />
  );
};

export default MarketStatusChip;
